import useDefaultSWR, { BareFetcher, Fetcher, Key } from "swr"

const defaultFetcher = async <T>(key: string): Promise<T | undefined> => {
    if (!key) return
    return fetch(key).then((res) => res.json())
}

const useSWRWithDefaultFetcher = (key: string, fetcher = defaultFetcher) => {
    const payload = useDefaultSWR(key, fetcher)
    return payload
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useSWRNoRevalidate = <T = any>(
    key: Key,
    fetcher: BareFetcher<T> = defaultFetcher<T> as BareFetcher<T>
) => {
    const payload = useDefaultSWR<T | undefined, Error, Key>(key, fetcher as Fetcher<T>, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        revalidateIfStale: false,
    })
    return payload
}

export const useSWR = useSWRWithDefaultFetcher
